import './app-footer.scss';

export const AppFooter = () => {

    return (
        <div className="app-footer">
            AT&T Proprietary (Restricted): Only for use by authorized individuals or any above-designated team(s) within the AT&T companies and not for general distribution.
        </div>
    );
};